import React from 'react'
import archivetick from '../../../assets/archive-tick.svg';
import documenttxt from '../../../assets/document-text.svg';
import ecLandingSection4Img from '../../../assets/EC_LP Creatives2-01.jpeg';
import ecLandingSection5Img from '../../../assets/EC_LP Creatives2-02.jpeg';
import ecLandingSection6Img from '../../../assets/EC_LP Creatives2-03.jpeg';
import ecLandingSection7Img from '../../../assets/EC_LP Creatives2-04.jpeg';
import eye from '../../../assets/eye.svg';
import heart from '../../../assets/heart.svg';
import message from '../../../assets/message.svg';
import profile2 from '../../../assets/profile-2user.svg';
import send2 from '../../../assets/send-2.svg';
import timer from '../../../assets/timer.svg';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Typography } from '@mui/material';
import ClientLogoSection from '../landingPages/client-logo-section';
import { Link } from 'react-router-dom';

function ECLandingSections() {
    return (
        <>
            {/* START :: Empowering businesses around the world */}
            <div className='pt-20 max-xs:mx-8 mx-16 xl:m-auto max-w-[93rem] max-xs:pt-8 '>
                <div className='font-sans text-20 xl:text-24 font-semibold text-center pb-12 max-xs:text-base'>Empowering businesses around the world</div>
                <ClientLogoSection />
                <div className="text-center pb-20  max-xs:pb-8">
                    <Link to="/blog">
                        <button className="bg-primary-500 text-white rounded-full w-[167px] h-10 text-14 xl:w-[175px] xl:h-12 font-bold">Read Case Studies</button>
                    </Link>
                </div>
            </div>

            {/*START :: Numbers that Given proven Results: */}
            <div className='bg-[#F9B4DA1A]'>
                <div className="flex flex-col gap-12 items-center bg-section3BgColor pt-12 pb-12  mx-16 xl:m-auto max-w-[93rem] max-xs:mx-0">
                    <div className="grid grid-cols-4  gap-12 max-lg:gap-8 max-xs:grid-cols-2 max-md:grid-cols-2 max-lg:grid-cols-2 max-xs:gap-6">
                        <div className="border-solid border-[0.3px] border-[#00000033] shadow-[0px_2px_6px_0px_rgba(0,0,0,0.1)] rounded-[5px] justify-center w-[200px] h-[200px] xl:w-[300px]  xl:h-[300px] flex flex-col items-center max-xs:w-36 max-xs:h-36 ">
                            <div className='text-center pb-4'>
                                <img className='ec-landing-section-3-logo w-10 h-10 xl:w-[60px] xl:h-[60px]' src={eye} alt="eye img" />
                            </div>
                            <span className="font-sans font-normal text-16 xl:text-20 text-[#00000099] pb-2.5 max-xs:text-xs">Total Views</span>
                            <span className="text-[32px] xl:text-40 font-semibold max-xs:text-base">10M+</span>
                        </div>
                        <div className="border-solid border-[0.3px] border-[#00000033] shadow-[0px_2px_6px_0px_rgba(0,0,0,0.1)] rounded-[5px] justify-center  w-[200px]  h-[200px] xl:w-[300px]  xl:h-[300px] flex flex-col items-center max-xs:w-36 max-xs:h-36">
                            <div className='text-center pb-4'>
                                <img className='ec-landing-section-3-logo w-10 h-10 xl:w-[60px] xl:h-[60px]' src={heart} alt="heart img" />
                            </div>
                            <span className="font-sans font-normal text-16 xl:text-20 text-[#00000099] pb-2.5 max-xs:text-xs">Total Likes</span>
                            <span className="text-[32px] xl:text-40 font-semibold max-xs:text-base">2.8K+</span>
                        </div>
                        <div className="border-solid border-[0.3px] border-[#00000033] shadow-[0px_2px_6px_0px_rgba(0,0,0,0.1)] rounded-[5px] justify-center  w-[200px]  h-[200px] xl:w-[300px]  xl:h-[300px] flex flex-col items-center max-xs:w-36 max-xs:h-36">
                            <div className='text-center pb-4'>
                                <img className='ec-landing-section-3-logo w-10 h-10 xl:w-[60px] xl:h-[60px]' src={message} alt="message img" />
                            </div>
                            <span className="font-sans font-normal text-16 xl:text-20 text-[#00000099] pb-2.5 max-xs:text-xs">Total Comments</span>
                            <span className="text-[32px] xl:text-40 font-semibold max-xs:text-base">8K+</span>
                        </div>
                        <div className="border-solid border-[0.3px] border-[#00000033] shadow-[0px_2px_6px_0px_rgba(0,0,0,0.1)] rounded-[5px] justify-center  w-[200px]  h-[200px] xl:w-[300px]  xl:h-[300px] flex flex-col items-center max-xs:w-36 max-xs:h-36">
                            <div className='text-center pb-4'>
                                <img className='ec-landing-section-3-logo w-10 h-10 xl:w-[60px] xl:h-[60px]' src={send2} alt="send2 img" />
                            </div>
                            <span className="font-sans font-normal text-16 xl:text-20 text-[#00000099] pb-2.5 max-xs:text-xs">Total Shares</span>
                            <span className="text-[32px] xl:text-40 font-semibold max-xs:text-base">10K+</span>
                        </div>
                    </div>
                    <div className="grid grid-cols-4 gap-24 max-lg:gap-8 max-xs:grid-cols-2 max-md:grid-cols-2 max-lg:grid-cols-2 max-xs:gap-6 max-md:gap-6">
                        <div className="border-solid border-[0.3px] border-[#00000033] shadow-[0px_2px_6px_0px_rgba(0,0,0,0.1)] rounded-[5px] justify-center  w-[200px] h-[200px] xl:w-[300px]  xl:h-[300px] flex flex-col items-center max-xs:w-36 max-xs:h-36">
                            <div className='text-center pb-4'>
                                <img className='ec-landing-section-3-logo w-10 h-10 xl:w-[60px] xl:h-[60px]' src={archivetick} alt="archivetick img" />
                            </div>
                            <span className="font-sans font-normal text-16 xl:text-20 text-[#00000099] pb-2.5 max-xs:text-xs">Total Saves</span>
                            <span className="text-[32px] xl:text-40 font-semibold max-xs:text-base">8K+</span>
                        </div>
                        <div className="border-solid border-[0.3px] border-[#00000033] shadow-[0px_2px_6px_0px_rgba(0,0,0,0.1)] rounded-[5px] justify-center  w-[200px]  h-[200px] xl:w-[300px]  xl:h-[300px] flex flex-col items-center max-xs:w-36 max-xs:h-36">
                            <div className='text-center pb-4'>
                                <img className='ec-landing-section-3-logo w-10 h-10 xl:w-[60px] xl:h-[60px]' src={timer} alt="timer img" />
                            </div>
                            <span className="font-sans font-normal text-16 xl:text-20 text-[#00000099] pb-2.5 max-xs:text-xs">Total Watch Times(Hrs)</span>
                            <span className="text-[32px] xl:text-40 font-semibold max-xs:text-base">136M Secs</span>
                        </div>
                        <div className="border-solid border-[0.3px] border-[#00000033] shadow-[0px_2px_6px_0px_rgba(0,0,0,0.1)] rounded-[5px] justify-center  w-[200px]  h-[200px] xl:w-[300px]  xl:h-[300px] flex flex-col items-center max-xs:w-36 max-xs:h-36">
                            <div className='text-center pb-4'>
                                <img className='ec-landing-section-3-logo w-10 h-10 xl:w-[60px] xl:h-[60px]' src={profile2} alt="profile2 img" />
                            </div>
                            <span className="font-sans font-normal text-16 xl:text-20 text-[#00000099] pb-2.5 max-xs:text-xs">Numbers of Creators</span>
                            <span className="text-[32px] xl:text-40  text-mdHeading1 font-semibold max-xs:text-base">500K+</span>
                        </div>
                        <div className="border-solid border-[0.3px] border-[#00000033] shadow-[0px_2px_6px_0px_rgba(0,0,0,0.1)] rounded-[5px] justify-center  w-[200px] h-[200px] xl:w-[300px]  xl:h-[300px] flex flex-col items-center max-xs:w-36 max-xs:h-36">
                            <div className='text-center pb-4'>
                                <img className='ec-landing-section-3-logo w-10 h-10 xl:w-[60px] xl:h-[60px]' src={documenttxt} alt="documenttxt img" />
                            </div>
                            <span className="font-sans font-normal text-16 xl:text-20 text-[#00000099] pb-2.5 max-xs:text-xs">Numbers of Content</span>
                            <span className="text-[32px] xl:text-40 font-semibold max-xs:text-base">500+</span>
                        </div>
                    </div>
                </div>
            </div>

            {/*START :: Find Your Ideal Creator for Your Brand*/}
            <div className="flex items-center mx-16 xl:m-auto max-w-[93rem] pt-20 gap-[100px] xl:gap-36 max-xs:flex max-xs:flex-col max-lg:flex-col max-md:flex-col justify-center max-xs:pl-8 max-xs:pr-8 max-xs:mx-0 max-xs:gap-[3rem] max-xs:pt-0">
                <img className='w-[524px] h-[407px] xl:w-[582px] xl:h-[451px] max-xs:h-full ' src={ecLandingSection4Img} alt="ec-landing-section-4-img" />
                <div className="w-[528px] xl:w-[762px] max-xs:w-auto">
                    <span className="font-sans text-30  xl:text-40 font-semibold ">
                        Find your <span style={{ color: '#F482C0' }}>Ideal Creator </span>for your <span style={{ color: '#F482C0' }} >Brand</span>
                    </span>
                    <Typography className='pt-10 xl:pt-14 pl-8'>
                        <ul>
                            <li className='list-disc'>
                                <span className='font-sans font-normal text-16 xl:text-20'>Discover the Ideal Creators and Achieve Campaign Success.</span>
                            </li>
                            <br></br>
                            <li className='list-disc'>
                                <span className='font-sans font-normal text-16 xl:text-20'> Utilize our affordable prices and complete campaign management to make smart choices.</span>
                            </li>
                        </ul>
                    </Typography>
                </div>
            </div>

            {/*START :: Find & Identify Your Ideal Creator Match*/}
            <div className="flex items-center mx-16 xl:m-auto max-w-[93rem] pt-20 gap-[83px] xl:gap-36 max-xs:flex-col-reverse  max-md:flex-col-reverse max-lg:flex-col-reverse justify-center max-xs:pl-8 max-xs:pr-8 max-xs:mx-0 max-xs:gap-[3rem] max-xs:pt-10" >
                <div className="xl:w-[737px] w-[580px] max-xs:w-auto">
                    <span className="font-sans text-30  xl:text-40 font-semibold max-xs:text-center">
                        Find &amp; Identify Your <span style={{ color: '#F482C0' }}>Ideal {window.innerWidth === 1280 ? <br /> : ' '} Creator  {window.innerWidth === 1728 ? <br /> : ' '}Match</span>
                    </span>
                    <Typography className='pt-10 xl:pt-14 pl-8'>
                        <ul>
                            <li className='list-disc'>
                                <span className='font-sans font-normal text-16 xl:text-20'>Explore a Range of Options: Demographics, Partnerships, Engagement, Content Affinity, Expert Support</span>
                            </li>
                            <br></br>
                            <li className='list-disc'>
                                <span className='font-sans font-normal text-16 xl:text-20'>Precision-Target Your Geographic Reach</span>
                            </li>
                            <br></br>
                            <li className='list-disc'>
                                <span className='font-sans font-normal text-16'>Align with Creators Perfectly Suited to Your Brand</span>
                            </li>
                            <br></br>
                            <li className='list-disc'>
                                <span className='font-sans font-normal text-16 xl:text-20'>Drive Campaign Success with Data-Backed Decisions</span>
                            </li>
                        </ul>
                    </Typography>
                </div>
                <div className="ec-landing-section-4-col-1">
                    <img className='w-[489px] h-[379px] xl:w-[607px] xl:h-[465px] max-xs:h-full' src={ecLandingSection5Img} alt="ec-landing-section-5-img" />
                </div>
            </div>

            {/*START :: Creator Recommendations from Past Data*/}
            <div className="flex items-centermx-16 xl:m-auto max-w-[93rem] mx-16 pt-20 gap-[120px] xl:gap-36 max-xs:flex max-xs:flex-col max-md:flex-col max-lg:flex-col justify-center max-xs:pl-8 max-xs:pr-8 max-xs:mx-0 max-xs:gap-[3rem] max-xs:pt-10 items-center">
                <img className='w-[489px] h-[379px] xl:w-[600px] xl:h-[465px] max-xs:h-full' src={ecLandingSection6Img} alt="ec-landing-section-6-img" />
                <div className="">
                    <span className="font-sans text-30  xl:text-40 font-semibold max-xs:flex max-xs:flex-colmax-xs:flex max-xs:flex-col max-xs:text-center max-md:text-center max-lg:text-center">
                        <span style={{ color: '#F482C0' }}>Creator Recommendations </span>from  {window.innerWidth === 1280 ? <br /> : ' '} Past  {window.innerWidth === 1728 ? <br /> : ' '} Data
                    </span>
                    <Typography className='pt-10 xl:pt-14 pl-8'>
                        <ul>
                            <li className='list-disc'>
                                <span className='font-sans font-normal text-16 xl:text-20'>Boost your creator selection with data-based recommendations.&nbsp;</span>
                            </li>
                            <br></br>
                            <li className='list-disc'>
                                <span className='font-sans font-normal text-16 xl:text-20'>Proactive suggestions based on successful past collaborations.</span>
                            </li>
                            <br></br>
                            <li className='list-disc'>
                                <span className='font-sans font-normal text-16 xl:text-20'>Identify creators with attributes similar to proven performers.&nbsp;</span>
                            </li>
                            <br></br>
                            <li className='list-disc'>
                                <span className='font-sans font-normal text-16 xl:text-20'>Optimize your influencer strategy with data-driven decision-making.</span>
                            </li>
                        </ul>
                    </Typography>
                </div>
            </div>

            {/*START :: Reporting & Recording of Every campaign */}
            <div className="flex  mx-16 xl:m-auto max-w-[93rem] pt-20 gap-[110px] xl:gap-36 max-xs:flex max-xs:flex-col-reverse max-md:flex-col-reverse max-lg:flex-col-reverse justify-center xl:pb-[112px] pb-28 max-xs:pb-8 max-xs:pl-8 max-xs:pr-8 max-xs:mx-0 max-xs:gap-[3rem] max-xs:pt-10 items-center">
                <div className="w-[521px] xl:w-[737px] max-xs:w-auto">
                    <span className="font-sans text-30  xl:text-40  font-semibold ">
                        <span style={{ color: '#F482C0' }}>Reporting &amp; Recording </span>of Every campaign&nbsp;
                    </span>

                    <Typography className='pt-10 xl:pt-14 pl-8'>
                        <ul className='list-disc'>
                            <li >
                                <span className='font-sans font-normal text-16 xl:text-20'>Build every campaign based on sentiment analysis and content analysis.</span>
                            </li>
                            <br></br>
                            <li className='list-disc'>
                                <span className='font-sans font-normal text-16 xl:text-20'>Utilize data-driven insights for each content creator.</span>
                            </li>
                            <br></br>
                            <li className='list-disc'>
                                <span className='font-sans font-normal text-16 xl:text-20'>Optimize campaigns with detailed sentiment and content analysis.</span>
                            </li>
                        </ul>
                    </Typography>
                </div>
                <div className="ec-landing-section-4-col-1">
                    <img className='w-[521px] h-[403px] xl:w-[607px] xl:h-[465px] max-xs:h-full' src={ecLandingSection7Img} alt="ec-landing-section-7-img" />
                </div>
            </div>
            <div className='ec-landing-section-padding'></div>
        </>
    )
}

export default ECLandingSections;
